import { render } from "./OrderSelect.vue?vue&type=template&id=29258fb3&scoped=true"
import script from "./OrderSelect.vue?vue&type=script&lang=js"
export * from "./OrderSelect.vue?vue&type=script&lang=js"

import "./OrderSelect.vue?vue&type=style&index=0&id=29258fb3&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29258fb3"]])

export default __exports__